import { Box, Typography } from '@mui/material'

import Tile from '@components/Tile'
import Alert from '@components/Alert'

export const Finish = () => {
    return (
        <Tile sx={{p: 0}}>
            <Box sx={{p: 2, pb: 0}}>
                <Typography variant={'h2'}>Firewall migration</Typography>
                <Alert severity={'success'} title={'Migration completed'} sx={{mt: 2, mb: 2}}>
                    <Typography variant={'body2'} sx={{mt: 1}}>The Landing-Zone is migrated to the new firewall</Typography>
                </Alert>
            </Box>
        </Tile>
    )
}

export default Finish